import { render, staticRenderFns } from "./FreeTextFormItem.vue?vue&type=template&id=354ab3da&scoped=true"
import script from "./FreeTextFormItem.vue?vue&type=script&lang=js"
export * from "./FreeTextFormItem.vue?vue&type=script&lang=js"
import style0 from "./FreeTextFormItem.vue?vue&type=style&index=0&id=354ab3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ab3da",
  null
  
)

export default component.exports